import { Redirect, Switch, useLocation } from 'react-router-dom'

import GoogleCallback from 'components/authentication/callbacks/Google'
import SAMLCallback from 'components/authentication/callbacks/SAML'
import ResetCompany from 'components/authentication/FindCompany'
import NewUser from 'components/authentication/registration/new-user/NewUser'
import Register from 'components/authentication/registration/register-company/Register'
import { AccountSetup } from 'components/authentication/registration/self-service/AccountSetup'
import RequestPasswordReset from 'components/authentication/RequestPasswordReset'
import ResetPassword from 'components/authentication/ResetPassword'
import SignIn from 'components/authentication/SignIn'
import SignInUsingSAML from 'components/authentication/SignInUsingSAML'
import JoinBootcamp from 'components/bootcamps/JoinBootcamp'
import TrackedGremlinRoute from 'components/TrackedGremlinRoute'
import theme from 'theme'

const UnauthenticatedRoutes: React.FC = () => {
  const { pathname, search } = useLocation()

  const sanitizedPathname = pathname.includes('/settings/team/')
    ? '/settings/teams'
    : pathname
  return (
    <div
      css={{
        backgroundColor: theme.colors.gray[0],
        position: 'relative'
      }}
    >
      <Switch>
        <TrackedGremlinRoute
          exact
          component={SignIn}
          name="Login"
          path="/login"
        />
        <TrackedGremlinRoute
          exact
          component={SignInUsingSAML}
          name="SAML Login"
          path="/login/saml"
        />
        <TrackedGremlinRoute
          exact
          component={(props) => <AccountSetup {...props} />}
          name="Account Setup"
          path="/setup"
        />
        <TrackedGremlinRoute
          exact
          component={(props) => <GoogleCallback {...props} />}
          path="/users/sso/google/login"
        />
        <TrackedGremlinRoute
          exact
          component={(props) => <SAMLCallback {...props} />}
          path="/users/sso/saml/acs"
        />
        <TrackedGremlinRoute
          exact
          component={(props) => <RequestPasswordReset {...props} />}
          name="Password Reset"
          path="/password-reset"
        />
        <TrackedGremlinRoute
          exact
          component={(props) => <ResetPassword {...props} />}
          path="/users/password/update"
        />
        <TrackedGremlinRoute
          exact
          component={(props) => <ResetCompany {...props} />}
          path="/find/company"
        />
        <TrackedGremlinRoute
          component={(props) => <Register {...props} />}
          name="Register"
          path="/register"
        />
        <TrackedGremlinRoute
          component={(props) => <NewUser {...props} />}
          name="New User Setup"
          path="/users/new"
        />
        <TrackedGremlinRoute
          exact
          component={JoinBootcamp}
          name="Join Bootcamp"
          path="/bootcamps/join/:companyId"
        />
        <Redirect
          to={{
            pathname: '/login',
            ...(pathname &&
              pathname !== '/' && {
                search: `next=${encodeURIComponent(
                  sanitizedPathname + (search ? search : '')
                )}`
              })
          }}
        />
      </Switch>
    </div>
  )
}

export default UnauthenticatedRoutes
